import { WX_DEFAULT_JSAPI_LIST } from '../config';
import { wxApiConfig } from './wx-js-sdk';

/** 隐藏微信右上角分享按钮 */
export const hiddenWxShareOption = () => {
  console.log('禁用微信右上角分享和状态栏');
  if (typeof WeixinJSBridge === 'undefined') {
    // 这个可以禁用安卓系统的右上角分享     （只针对微信端）
    document.addEventListener(
      'WeixinJSBridgeReady',
      function () {
        WeixinJSBridge.call('hideToolbar');
        WeixinJSBridge.call('hideOptionMenu');
      },
      false
    );
  } else {
    // 这个可以禁用ios系统的右上角分享      （只针对微信端）
    WeixinJSBridge.call('hideToolbar');
    WeixinJSBridge.call('hideOptionMenu');
  }
};

/** 显示微信右上角按钮 */
export const showWxShareOption = () => {
  console.log('启用微信右上角分享和状态栏');
  if (typeof WeixinJSBridge === 'undefined') {
    // 这个可以禁用安卓系统的右上角分享     （只针对微信端）
    document.addEventListener(
      'WeixinJSBridgeReady',
      function () {
        WeixinJSBridge.call('showToolbar');
        WeixinJSBridge.call('showOptionMenu');
      },
      false
    );
  } else {
    // 这个可以禁用ios系统的右上角分享      （只针对微信端）
    WeixinJSBridge.call('showToolbar');
    WeixinJSBridge.call('showOptionMenu');
  }
};

/**
 * 隐藏企业微信右上角分享
 */
let wxConfigHiddenTimer: number;
export const hiddenQyWxShareOption = () => {
  wxConfigHiddenTimer && clearTimeout(wxConfigHiddenTimer);
  wxConfigHiddenTimer = window.setTimeout(() => {
    wxApiConfig(WX_DEFAULT_JSAPI_LIST)
      .then(() => {
        console.log('企业微信环境屏蔽右上角分享');
        wx.hideOptionMenu();
        wx.showMenuItems({
          menuList: ['menuItem:copyUrl'], // 复制链接
        });
      })
      .catch((err) => {
        console.error('企业微信环境隐藏右上角分享 error', err);
      });
  }, 300);
};

/**
 * 显示企业微信右上角分享
 */
let wxConfigShowTimer: number;
export const showQyWxShareOption = () => {
  wxConfigShowTimer && clearTimeout(wxConfigShowTimer);
  wxConfigShowTimer = window.setTimeout(() => {
    wxApiConfig(WX_DEFAULT_JSAPI_LIST)
      .then(() => {
        console.log('企业微信环境显示右上角分享');
        wx.showOptionMenu();
      })
      .catch((err) => {
        console.error('企业微信环境显示右上角分享 error', err);
      });
  }, 300);
};
